function initSectionDropdown() {
    document.body.addEventListener('click', (e) => {
        const target = e.target;
        if (!target) {
            return;
        }

        const button = target.closest('[data-section-dropdown-button]');
        if (!button) {
            return;
        }

        e.preventDefault();

        const dropdown_id = button.getAttribute('aria-controls');
        if (!dropdown_id) {
            return;
        }

        const dropdown = document.getElementById(dropdown_id);
        if (!dropdown) {
            return;
        }

        const open = button.getAttribute('aria-expanded') === 'true';

        const buttons = document.querySelectorAll(`[data-section-dropdown-button][aria-controls="${dropdown_id}"]`);

        if (open) {
            buttons.forEach((button) => {
                button.setAttribute('aria-expanded', 'false');
            });

            dropdown.setAttribute('aria-hidden', 'true');
        } else {
            buttons.forEach((button) => {
                button.setAttribute('aria-expanded', 'true');
            });

            dropdown.setAttribute('aria-hidden', 'false');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initSectionDropdown();
});